<script lang="ts">
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import { FormTemplateItemType as ItemType } from '../../../modules/toolsApi/forms/form-templates/form-template-item-type.enum'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import ContentText from './static_text.svelte'
    import { DragAndDrop } from '../../pipeline/dragAndDrop/dragAndDrop.js'
    import InputText from './input_text.svelte'
    import InputRadioCheck from './input_radio_check.svelte'
    import InputSign from './input_sign.svelte'
    import InputBeforeAfter from './input_before-after.svelte'
    import InputFitzpatrick from './input_fitzpatrick.svelte'
    import InputHairStroke from './input_hair_stroke.svelte'
    import InputTextFormated from './input_text_formated.svelte'
    import ImageGallery from './image-gallery.svelte'
    import Fa from 'svelte-fa'
    import {
        faCalendarAlt,
        faCheckCircle,
        faCheckSquare,
        faFileAlt,
        faGripLines,
        faHandPointer,
        faImages,
        faKeyboard,
        faSignature,
        faWindowMinimize,
    } from '@fortawesome/free-solid-svg-icons'
    import InputText_2 from './input_text_2.svelte'
    import SharePageHeader from '../../_common/share-page-header.svelte'
    import SharePageFooter from '../../_common/share-page-footer.svelte'
    const dispatch = createEventDispatcher()

    export let items: FormTemplateItem[] = []
    export let editable
    export let appearence = 'default'
    export let showHeaders: boolean

    let newItem: FormTemplateItem = null
    async function createNewEntity(type: ItemType, cloned: FormTemplateItem = null) {
        console.log('trace_createNewEntity')
        newItem = new FormTemplateItem()
        newItem.id = crypto.randomUUID()
        newItem.type = type
        newItem.enabled = true
        //
        newItem.content = cloned?.content || []
        newItem.label = cloned?.label || ''
        newItem.required = cloned?.required || false
        newItem.locked = cloned?.locked || false
        newItem.score = cloned?.score || false
        items.push(newItem)
        items = items
        setTimeout(() => bindDrag(), 100)
    }

    let step = 1
    function addNewItemSelect() {
        dispatch('change')
        step = 2
    }
    async function addNewItemEdit(type: ItemType) {
        await createNewEntity(type)
        dispatch('change')
        step = 1
    }

    async function goClone(ev) {
        await createNewEntity(ev.detail.type, ev.detail)
        dispatch('change')
        window.alert('Campo duplicado com sucesso.\nO novo campo foi adicionado ao final do documento.')
    }

    let dd = null
    function bindDrag() {
        dd = new DragAndDrop('frms')
        dd.callback = (result) => {
            listReordered(result)
        }
    }

    $: {
        if (dd) {
            dd.enabled = !isEditingItem
        }
    }

    async function listReordered(result) {
        console.log('--------------')
        console.log('re_frm_to', result.source.index, result.destination.index)
        console.log('items_ori', Object.assign([], items))
        for (const item of items) {
            console.log('ori', item.content)
        }
        let element = items[result.source.index]
        items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, element)
        console.log('items_new', items)
        for (const item of items) {
            console.log('new', item.content)
        }
        let _items = Object.assign([], items)
        items = []
        dispatch('change')
        await tick()
        items = _items
        await tick()
        setTimeout(() => bindDrag(), 100)
    }

    onMount(() => {
        setTimeout(() => bindDrag(), 100)
        startTest()
    })

    function startTest() {
        //addNewItemEdit(ItemType.text_short)
    }

    function contentTextOnRemove() {
        items = items.filter((el) => !!el)
        dispatch('change')
        step = 1
        isEditingItem = false
    }

    let isEditingItem = false

    function onIsEditingItem(ev) {
        dispatch('change')
        isEditingItem = ev.detail
    }
</script>

<div class="frms">
    {#if showHeaders}
        <SharePageHeader company={window.store.company} position="relative"></SharePageHeader>
    {/if}
    <div class="frms_ordering {appearence}" data-id="frms" id="frms">
        {#each items as item, i (item.id + '_' + i)}
            <div data-id="i_{item.id}" id="i_{item.id}" class="frm">
                {#if item.type === ItemType.label_formated}
                    <ContentText {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></ContentText>
                {/if}
                {#if item.type === ItemType.text_short}
                    <InputText {editable} on:edit={onIsEditingItem} bind:item type="single" on:remove={contentTextOnRemove} on:clone={goClone}></InputText>
                {/if}
                {#if item.type === ItemType.text_long}
                    <InputText {editable} on:edit={onIsEditingItem} bind:item type="multi" on:remove={contentTextOnRemove} on:clone={goClone}></InputText>
                {/if}
                {#if item.type === ItemType.date}
                    <InputText {editable} on:edit={onIsEditingItem} bind:item type="date" on:remove={contentTextOnRemove} on:clone={goClone}></InputText>
                {/if}
                {#if item.type === ItemType.text_formated}
                    <InputTextFormated {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></InputTextFormated>
                {/if}
                {#if item.type === ItemType.choice_one}
                    <InputRadioCheck {editable} on:edit={onIsEditingItem} bind:item multi={false} on:remove={contentTextOnRemove} on:clone={goClone}
                    ></InputRadioCheck>
                {/if}
                {#if item.type === ItemType.choice_multiple}
                    <InputRadioCheck {editable} on:edit={onIsEditingItem} bind:item multi={true} on:remove={contentTextOnRemove} on:clone={goClone}
                    ></InputRadioCheck>
                {/if}
                {#if item.type === ItemType.sign}
                    <InputSign isNew={newItem?.id === item.id} {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}
                    ></InputSign>
                {/if}
                {#if item.type === ItemType.before_after}
                    <InputBeforeAfter {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></InputBeforeAfter>
                {/if}
                {#if item.type === ItemType.fitzpatrick}
                    <InputFitzpatrick {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></InputFitzpatrick>
                {/if}
                {#if item.type === ItemType.hair_stroke}
                    <InputHairStroke {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></InputHairStroke>
                {/if}
                {#if item.type === ItemType.image_gallery}
                    <ImageGallery paint={false} {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}
                    ></ImageGallery>
                {/if}
                {#if item.type === ItemType.image_paint}
                    <ImageGallery paint={true} {editable} on:edit={onIsEditingItem} bind:item on:remove={contentTextOnRemove} on:clone={goClone}></ImageGallery>
                {/if}
            </div>
        {/each}
    </div>
    {#if editable}
        {#if step === 1}
            <button on:click={addNewItemSelect} class="btn btn-primary btn_new-item my-5">Adicionar novo item...</button>
        {/if}
        {#if step === 2}
            <div class="frm add-items">
                <div class="cs_item_title">Adicione um item no documento</div>
                <div class="cs_item_subtitle">Conteúdo não editável</div>
                <div class="add-items_list">
                    <button on:click={() => addNewItemEdit(ItemType.label_formated)} class="add-items_list_item">
                        <Fa icon={faFileAlt}></Fa>
                        Texto com formatação
                    </button>
                </div>
                <div class="cs_item_subtitle">Campos de digitação</div>
                <div class="add-items_list">
                    <button on:click={() => addNewItemEdit(ItemType.text_short)} class="add-items_list_item">
                        <Fa icon={faWindowMinimize}></Fa>
                        Campo de 1 linha
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.text_long)} class="add-items_list_item">
                        <Fa icon={faGripLines}></Fa>
                        Campo multilinhas
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.choice_one)} class="add-items_list_item">
                        <Fa icon={faCheckCircle}></Fa>
                        Campo de escolha única
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.choice_multiple)} class="add-items_list_item">
                        <Fa icon={faCheckSquare}></Fa>
                        Campo de escolha múltipla
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.date)} class="add-items_list_item">
                        <Fa icon={faCalendarAlt}></Fa>
                        Campo de data
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.text_formated)} class="add-items_list_item">
                        <Fa icon={faKeyboard}></Fa>
                        Editor de texto
                    </button>
                </div>
                <div class="cs_item_subtitle">Outros campos</div>
                <div class="add-items_list">
                    <button on:click={() => addNewItemEdit(ItemType.sign)} class="add-items_list_item">
                        <Fa icon={faSignature}></Fa>
                        Campo de assinatura
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.before_after)} class="add-items_list_item">
                        <Fa icon={faImages}></Fa>
                        Antes e Depois
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.image_gallery)} class="add-items_list_item">
                        <Fa icon={faImages}></Fa>
                        Upload de Imagens
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.image_paint)} class="add-items_list_item">
                        <Fa icon={faImages}></Fa>
                        Imagens com marcação
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.fitzpatrick)} class="add-items_list_item">
                        <Fa icon={faHandPointer}></Fa>
                        Tipo de pele (escala Fitzpatrick)
                    </button>
                    <button on:click={() => addNewItemEdit(ItemType.hair_stroke)} class="add-items_list_item">
                        <Fa icon={faHandPointer}></Fa>
                        Espessura do pelo
                    </button>
                </div>
            </div>
        {/if}
    {/if}
    {#if showHeaders}
        <SharePageFooter company={window.store.company} position="relative" createdAt={new Date()}></SharePageFooter>
    {/if}
</div>

<style>
    :global(.ql-toolbar) {
        background-color: white;
    }
    .editor {
        background-color: #ccc;
        color: black;
        height: 220px;
        font-size: 18px;
        overflow: auto !important;
        min-height: 220px;
    }
    .no-selection {
        user-select: none;
    }
    :global(.ql-editor) {
        max-width: unset;
        margin: 0px 0px;
        background-color: white;
        overflow: unset !important;
        height: unset !important;
        min-height: 1460px;
    }
    :global(.ql-editor ol, .ql-editor ul) {
        padding-left: 0px !important;
    }

    .field-background {
        background: #99999910;
        margin-top: 2px;
        margin-bottom: 2px;
    }

    @media (max-width: 900px) {
        .item-static button {
            margin-top: 6px !important;
            margin-bottom: 8px !important;
        }
    }
</style>
